import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { Link } from '@fiverr-private/typography';
import { Domingo } from '@fiverr-private/domingo';
import { translate } from '../../../utils/translate';

export const BecomeSellerLink: React.FC<{ source?: string }> = ({ source = 'not_defined' }) => {
    const { url } = getContext();

    const linkHref = Domingo(url).removePro().path(
        'content_pages_page',
        { page_slug: 'pro-freelancers' },
        {
            query: { source },
        }
    ).url;

    return (
        <Link
            href={linkHref}
            decoration="underline"
            fontWeight="semibold"
            cursor="pointer"
            size={{ default: 'b_sm', md: 'b_md' }}
        >
            {translate('steps.initial.sign_up.offer_services')}
        </Link>
    );
};
